import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const carouselImages = ['https://cdn.magicpatterns.com/uploads/iuqCikMWjHJyidDZ9w1xUu/test2.webp', 'https://cdn.magicpatterns.com/uploads/1LBZjEPAqF6Lr1GeZXCxCy/test3.webp', 'https://cdn.magicpatterns.com/uploads/oQ2M77cKFejM38JkicNtop/test4.webp', 'https://cdn.magicpatterns.com/uploads/7pggpnBU4vjWjguCn9wiWX/test5.webp', 'https://cdn.magicpatterns.com/uploads/dncH9DRXSXUTqdpqGPTrYU/test6.webp'];
export function SocialProof() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1);
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? carouselImages.length - 1 : prevIndex - 1);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(timer);
  }, [nextSlide, currentIndex]); // Added currentIndex to reset timer on manual change
  return <>
      {/* Chef Bio Section */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-223">
        <div className="max-w-5xl mx-auto" data-id="element-224">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center" data-id="element-225">
            {/* Photo */}
            <div className="flex justify-center" data-id="element-226">
              <img src="https://cdn.magicpatterns.com/uploads/eoHMTE2kkyGRhPN8Tawkuu/ChatGPT_Image_Mar_13,_2026,_11_09_54_PM.webp" alt="Chef Carla Ramos preparando masa sin glúten" className="w-full max-w-md rounded-2xl shadow-lg object-cover" loading="lazy" data-id="element-227" />
            </div>

            {/* Bio Text */}
            <div className="flex flex-col gap-4" data-id="element-228">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-brown" data-id="element-229">
                <span className="italic" data-id="element-230">Chef</span> Alessandra Mora
              </h2>

              <p className="text-brand-brownLight leading-relaxed" data-id="element-231">
                Soy Alessandra Mora, chef profesional especializada en{' '}
                <span className="font-bold text-brand-brown" data-id="element-232">
                  panadería y repostería sin gluten
                </span>
                , y colombiana hasta los huesos.
              </p>

              <p className="text-brand-brownLight leading-relaxed" data-id="element-233">
                A los 34 me diagnosticaron sensibilidad al gluten no celíaca. El
                médico fue claro:{' '}
                <span className="font-bold text-brand-brown" data-id="element-234">
                  el gluten tenía que desaparecer de mi vida para siempre.
                </span>
              </p>

              <p className="text-brand-brownLight leading-relaxed" data-id="element-235">
                Lo primero que pensé fue:{' '}
                <span className="italic" data-id="element-236">¿y el pan? ¿y mis postres?</span>
              </p>

              <p className="text-brand-brownLight leading-relaxed" data-id="element-237">
                Probé decenas recetas de YouTube, TikTok, Facebook... el
                resultado siempre era el mismo:{' '}
                <span className="font-bold text-brand-brown" data-id="element-238">
                  seco y sin sabor.
                </span>{' '}
              </p>
              <p className="font-bold text-brand-brown" data-id="element-239">
                Gasté fortunas en harinas que terminaron en la basura.
              </p>

              <p className="text-brand-brownLight leading-relaxed" data-id="element-240">
                Hasta que dejé de seguir recetas y empecé a{' '}
                <span className="font-bold text-brand-brown" data-id="element-241">
                  entender la ciencia detrás del pan sin gluten.
                </span>{' '}
              </p>

              <p className="text-brand-brownLight leading-relaxed" data-id="element-242">
                Hoy hago pan que se dobla sin romperse, postres que mi familia
                pide todos los fines de semana y{' '}
                <span className="font-bold text-brand-brown" data-id="element-243">
                  y nadie se da cuenta que son "sin gluten" y sin azúcar hasta
                  que se los digo.
                </span>
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-5 px-4 bg-brand-creamAlt" data-id="element-244">
        <div className="max-w-7xl mx-auto" data-id="element-245">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-10" data-id="element-246">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-brown mb-4" data-id="element-247">
              LO QUE DICEN NUESTROS CLIENTES
            </h2>
            <div className="w-24 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-248"></div>
          </motion.div>

          <div className="relative max-w-sm mx-auto" data-id="element-249">
            {/* Carousel Container */}
            <div className="relative aspect-[9/16] w-full rounded-2xl overflow-hidden shadow-xl bg-white flex items-center justify-center" data-id="element-250">
              <AnimatePresence data-id="element-251">
                <motion.img key={currentIndex} src={carouselImages[currentIndex]} alt={`Testimonio ${currentIndex + 1}`} initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} exit={{
                opacity: 0
              }} transition={{
                duration: 0.5
              }} className="absolute inset-0 w-full h-full object-contain" data-id="element-252" />
              </AnimatePresence>
            </div>

            {/* Navigation Arrows */}
            <button onClick={prevSlide} className="absolute top-1/2 -left-4 md:-left-12 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center text-brand-brown hover:scale-110 transition-transform z-10" aria-label="Testimonio anterior" data-id="element-253">
              <ChevronLeftIcon className="w-6 h-6" data-id="element-254" />
            </button>

            <button onClick={nextSlide} className="absolute top-1/2 -right-4 md:-right-12 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center text-brand-brown hover:scale-110 transition-transform z-10" aria-label="Siguiente testimonio" data-id="element-255">
              <ChevronRightIcon className="w-6 h-6" data-id="element-256" />
            </button>

            {/* Dot Indicators */}
            <div className="flex justify-center gap-2 mt-6" data-id="element-257">
              {carouselImages.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-colors ${idx === currentIndex ? 'bg-brand-terracotta' : 'bg-brand-brown/20'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-258" />)}
            </div>
          </div>
        </div>
      </section>
    </>;
}